import React from 'react';
import {
    withStyles,
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    Grid,
    Typography,
    ButtonBase,
    Divider,
    List,
    Avatar,
} from '@material-ui/core';
import './redBag.css'

import {
    withRouter,
} from "react-router-dom"

import AppData from '../../model/AppData';
import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import DateUtils from '../../control/dateutils';
import AppUtils from '../../control/apputlis';
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';
import MNineAvatar from '../view/MNineAvatar';
import FIMUtils from '../../im/FIMUtils';
import StringUtils from '../../net/IMStringUtils';

const SVIP_ICON = require('../../images/change/default_avatar.png');
const NoChat = require('../../images/icons/noChat.png');

class ChatPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            avatar: AppData.me.Pic,
            sysmsg: [],
            conversationList: [],
        }
        document.body.style.overflow = 'scroll';

        console.log('ChatPage', props);
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'ChatPage');
        IMEventEmitter.on(IMEvent.UPDATE_CONVERSATION_LIST, this.getConversations, this);
        if (!AppData.me.isLogin()) {

            AppData.login();

        }
        this.getSystemMessage();
        this.getConversations();
        document.body.style.overflow = 'scroll';

    }

    componentWillUnmount() {
        this.setState = () => false;
        IMEventEmitter.off(IMEvent.UPDATE_CONVERSATION_LIST, this.getConversations, this);
    }


    getSystemMessage = async () => {
        let result = await Apis.encryptionSystemMessage();
        console.log('getSystemMessage', result);
        if (result.code == 200) {
            this.setState({ sysmsg: result.data });
        }
    }

    getConversations = async () => {
        let result = await FIMUtils.getConversationList(); 
        if (result) {
            this.setState({ conversationList: result });
        }

    }

    _onListItemClick = (data) => {
        let nick = data.titleName;
        let userId = data.conversationId;
        if (data) {
            if (data.isGroup) {
                this.props.history.push({ pathname: '/privateletter/' + userId + '/groupProfile', data: nick });
            } else {
                this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: nick });
            }
        }
    }

    _onClickSysMsg = () => {
        console.log('_onClickSysMsg');
        const { sysmsg } = this.state;
        this.props.history.push({ pathname: '/sysmessage/', data: sysmsg });
    }

    _onSearchFriend = () => {
        const { sysmsg } = this.state;
        this.props.history.push({ pathname: '/chatsearchfriend/', data: sysmsg });
    }

    onChatBookClick = () => {
        this.props.history.push({ pathname: '/chatbook/' });
    }

    onQunliao = () => {
        this.props.history.push({ pathname: '/chatgroup/' });
    }

    onAddNewFriend = () => {
        this.props.history.push({ pathname: '/chataddfriend/' });
    }

    renderItem = (data, n) => {
        const { classes } = this.props;
        let showPoint = data.unreadCount > 0;

        if (data.lastMsgName == '您已不在本群聊') {
            return (
                <></>
            )
        }

        let nick = data.titleName;
        if (data && data.titleName && data.titleName.length > 20) {
            nick = StringUtils.adapterString(data.titleName, 20);
        }
        let heads = []
        
        if (data.isGroup) {
            let uids = []
            uids.push(AppData.me.Uid)
            uids.push(data.lastMessage.uid)
            heads = [data.lastMessage.headurl]
           
            nick = AppData.me.Username + ',' + data.lastMessage.nickname;
            data.titleName = nick
        }else{
            heads = data.headurls
        }
        //聊天信息的每一个会话
        return (
            <div style={{ marginTop: 15 }} key={n + ''} >
                <ListItem disableRipple button onClick={() => this._onListItemClick(data)} style={{ paddingLeft: 8, paddingRight: 8, margin: 0, paddingTop: 0, paddingBottom: 0 }}>
                    <Grid container direction='row' alignItems="center" justifycontent='space-between'>
                        <Grid container direction='row' style={{ flex: 1 }}>
                            <Grid container direction='row' style={{ alignItems: 'flex-start', width: 46 }}>
                                <MNineAvatar imgs={heads} size={40} />
                                {
                                    showPoint && <Grid style={{ backgroundColor: '#FC3035', marginLeft: 0, marginBottom: 4, width: 6, height: 6, borderRadius: 3 }} />
                                }
                            </Grid>
                            <Grid style={{ alignItems: 'flex-start', maxWidth: '70%', marginLeft: 6 }}>
                                <Typography style={{ color: '#0D0D0D', fontSize: 14 }}>{nick}</Typography>
                                <Typography noWrap className={classes.contents} style={{ width: 200 }}>{data.lastMsgContent}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container direction='row' className='flexEnd' style={{ maxWidth: 96 }}>
                            <Typography className={classes.contents} >{data.lastMessage && DateUtils.dateFormat1(data.lastMessage.msgtime)}</Typography>
                        </Grid>
                    </Grid>

                    {/* #FAFAFA */}
                </ListItem>
                <div style={{ marginRight: 20, marginTop: 15 }}>
                    <Divider light style={{ background: '#E2E2E2', width: '100%', height: '0.5px', justifycontent: 'center', marginLeft: 60, }} />

                </div>
            </div>

        );
    }

    render() {
        const { classes } = this.props;
        const { conversationList, sysmsg } = this.state;
        let content = '';
        if (sysmsg.length > 0) {
            content = sysmsg[0].content;
        }
        let title = '消息';

        let { hidden } = this.props.match.params;
        // hidden
        
        let hideBack = hidden == 1?false:true;
        if (AppData.ServerConfig && AppData.ServerConfig.tap_show == 1) {
            title = '我的通讯';
            hideBack = false;
        }


        let is_has_add_friend = true;
        if (AppData.ServerConfig) {
            is_has_add_friend = AppData.ServerConfig.is_has_add_friend
        }


        return (
            <MBack title={title} hideBack={hideBack}>
                <Grid style={{ height: 16 }}></Grid>
                <Grid container justifycontent='flex-start'>
                    {
                        sysmsg.length > 0 && <Typography className={classes.tittle}>官方通知</Typography>
                    }
                    {
                        sysmsg[0] && <ListItem disableRipple button onClick={() => this._onClickSysMsg()} style={{ paddingLeft: 8, paddingRight: 8, margin: 0 }}>
                            <Grid container direction='row' alignItems="center" justifycontent='space-between'>
                                <Grid container direction='row' style={{ flex: 1 }}>
                                    <img src={SVIP_ICON} alt='' className={classes.menuIcon} />
                                    <Grid style={{ alignItems: 'flex-start', maxWidth: '50%' }}>
                                        <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 10 }}>{sysmsg[0] ? sysmsg[0].title : ''}</Typography>
                                        <Typography noWrap className={classes.contents} style={{ width: 200, marginLeft: 10 }}>{sysmsg[0] ? sysmsg[0].content : ''}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justifycontent='flex-end' style={{ maxWidth: 96 }}>
                                    <Typography className={classes.contents} style={{ marginLeft: 20 }}>{sysmsg[0] ? DateUtils.dateFormatMDNoWeek(sysmsg[0].addTime) : ''}</Typography>
                                </Grid>
                            </Grid>
                        </ListItem>
                    }
                </Grid>
                {
                    sysmsg.length > 0 && <Grid container justifycontent='center'>
                        <Divider light style={{ background: '#FAFAFA', width: '100%', justifycontent: 'center' }} />
                    </Grid>
                }
                {/* <Grid container style={{ height: 10 }}></Grid> */}
                {/* {
                    conversationList.length > 0 && <Typography className={classes.tittle}>聊天信息</Typography>
                } */}

                {conversationList.length >0 && 
                <Grid container justifycontent='flex-start' >
                    <List style={{ width: '100%', paddingTop: 0,marginBottom:70 }}>
                        {
                            conversationList && conversationList.map((data, n) => (
                                this.renderItem(data, n)
                            ))
                        }
                    </List>
                </Grid>
                }
                {conversationList.length  == 0 && <div className={classes.centeImg}>
                    <img className={classes.centeImga} src={NoChat}></img>
                        <div style={{fontSize:12,color:'#919191'}}>暂无信息</div>
                    </div>}
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    centeImg:{
        display: 'flex',
        flexDirection: 'column',
        
        justifyContent: 'center',
        alignItems: 'center',
        marginTop:60
    },
    centeImga:{
        width:250,height:250
    },
    tittle: {
        color: '#0D0D0D',
        padding: theme.spacing(0, 2),
        fontSize: 14,
    },

    contents: {
        color: '#878787',
        fontSize: 12,
    },
    menuIcon: {
        color: theme.palette.secondary,
        margin: theme.spacing(0),
        width: 40,
        height: 40,
    },
    divider: {
        width: '100vw',
        height: 10,
        backgroundColor: '#FAFAFA',
        margin: theme.spacing(1, 0, 1, 0),
    }


}))(ChatPage));